import { createFileRoute, redirect } from '@tanstack/react-router';

import { PERMISSIONS as P, projectPermissions } from '@/app/permissions';
import { bootSession } from '@/lib/auth/session';

export const Route = createFileRoute('/_app/projects/$projectId/workforce/')({
  beforeLoad: async ({ params }) => {
    // The owner side's payer has no crew view: send them straight to payroll.
    // A subcontractor starts at its own workers (workforce.view_own / manage_own).
    const { me } = await bootSession();
    const granted = projectPermissions(me, params.projectId);
    const roster =
      granted.has(P.workforceView) ||
      granted.has(P.workforceViewOwn) ||
      granted.has(P.workforceManageOwn);
    throw redirect({
      to: roster
        ? '/projects/$projectId/workforce/crew'
        : granted.has(P.crewsManage)
          ? '/projects/$projectId/workforce/crews'
          : '/projects/$projectId/workforce/payroll',
      params,
      replace: true,
    });
  },
});
